import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'
import { useRouter } from 'solito/router'

import Button from 'app/components/base/Button'
import Stack, { StackProps } from 'app/components/base/Stack'

const SignInHeaderBlock = ({ sx = {}, ...props }: Partial<StackProps>) => {
  const router = useRouter()

  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{ width: { xs: '100%', md: 'auto' }, alignItems: 'center', ...sx }}
      {...props}
    >
      <Button
        aria-label="sell with us"
        variant="outlined"
        size="small"
        sx={{
          backgroundColor: 'background.default',
          ...Platform.select({ native: { flex: 1 } }),
          width: { md: 120 }
        }}
        {...Platform.select({
          web: { onClick: () => router.push('/sign-up') },
          native: { onPress: () => router.push('/sign-up') }
        })}
      >
        <FormattedMessage defaultMessage="Sell With Us" />
      </Button>

      <Button
        variant="contained"
        size="small"
        sx={{
          backgroundColor: '#32427E',
          ...Platform.select({ native: { flex: 1 } }),
          width: { md: 107 }
        }}
        {...Platform.select({
          web: { onClick: () => router.push('/sign-in') },
          native: { onPress: () => router.push('/sign-in') }
        })}
      >
        <FormattedMessage defaultMessage="Sign in" />
      </Button>
    </Stack>
  )
}

export default SignInHeaderBlock
